import React, { useContext } from "react";
import { Navigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import LoadingLines from "./LoadingLines";

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useContext(AuthContext);

  if (loading) {
    return <LoadingLines fullScreen />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Onboarding is no longer a hard gate — the OnboardingBanner nudges the
  // user globally instead. Lets first-time users explore Holdings / Portfolio
  // before committing to the wizard. Welcome.jsx still self-redirects to
  // /portfolio if onboarding_completed is already true.
  return children;
};

export default ProtectedRoute;
